import { Grid, TextField, Typography, makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ErrorToast } from '../utils/Utils';
import { showProgress } from '../../redux/actions/DealershipActions';
import service from '../../apis/service';
import { apiEndpoints } from '../../constants/apiEndpoints';
import Image from '../common/Image';

const useStyle = makeStyles({
  container: {
    width: '100%',
    display: 'flex',
    gap: '15px',
    flexDirection: 'column',
    alignItems: 'center',
  },
  heading: {
    fontSize: '18px',
    fontWeight: '700',
    width: '98%',
  },
  messages: {
    width: '98%',
    display: 'flex',
    gap: '20px',
    flexWrap: 'wrap',
  },
  msg: {
    padding: '15px',
    border: '1px solid #622FEE',
    color: '#622FEE',
    background: 'white',
    borderRadius: '10px',
    cursor: 'pointer',
  },
  selectedMsg: {
    padding: '15px',
    border: '1px solid #622FEE',
    color: 'white',
    background: '#622FEE',
    borderRadius: '10px',
    cursor: 'pointer',
  },
  textField: {
    width: '96%',
    border: '1px solid #E4E7EC',
    padding: '10px',
    marginTop: '10px',
    background: '#fff',
    borderRadius: '6px',
  },
  msgTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '98%',
  },
  guideBox: {
    width: '50%',
    height: '100px',
    padding: '10px',
    borderRadius: '6px',
    background: '#fff',
    display: 'flex',
    gap: '10px',
  },
  guideContent: {
    width: '80%',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
});

export default function MessageList({ message, setMessage, customMsg, setCustomMsg, slectedGuide, slectedJ }) {
  const classes = useStyle();
  const dispatch = useDispatch();

  const [messages, setMasseges] = useState([]);

  useEffect(() => {
    getMessages();
  }, []);

  const getMessages = async () => {
    dispatch(showProgress(true));
    try {
      const res = await service.get(apiEndpoints.DEALER_MESSAGES);
      setMasseges(res);
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  const handleChange = (e) => {
    const inp = e.target.value;
    if (inp.length <= 75) {
      setCustomMsg(e.target.value);
    }
  };

  return (
    <Grid className={classes.container}>
      <Typography className={classes.heading}>Selected Guide</Typography>
      <Grid style={{ width: '98%' }}>
        <Grid className={classes.guideBox}>
          <Grid style={{ width: '20%' }}>
            <Image
              src={slectedGuide.thumbnail}
              alt="profile"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </Grid>
          <Grid className={classes.guideContent}>
            <Typography varient="p" style={{ fontSize: '12px' }}>
              {slectedJ.journeyTitle}
            </Typography>
            <Typography style={{ fontSize: '16px', fontWeight: '700' }}>{slectedGuide.title}</Typography>
          </Grid>
        </Grid>
      </Grid>
      <div style={{ height: '1px', width: '98%', background: '#E4E7EC' }}></div>
      <Typography className={classes.heading} style={{ marginTop: '20px' }}>
        Select a message below
      </Typography>
      <Grid className={classes.messages}>
        {messages.map((msg) => (
          <Typography
            className={message.id === msg.id ? classes.selectedMsg : classes.msg}
            key={msg.id}
            onClick={() => (message.id === msg.id ? setMessage({}) : setMessage(msg))}
          >
            {msg.message}
          </Typography>
        ))}

        {messages.length > 1 ? (
          <Typography
            className={message.id === -1 ? classes.selectedMsg : classes.msg}
            onClick={() => (message.id === -1 ? setMessage({}) : setMessage({ id: -1, message: '' }))}
          >
            + Add Custom Message
          </Typography>
        ) : null}
      </Grid>
      {message.id === -1 ? (
        <Grid style={{ width: '100%', marginTop: '20px' }}>
          <Grid className={classes.msgTitle}>
            <Typography>Custom message</Typography>
            <Typography>{customMsg.length}/75</Typography>
          </Grid>
          <TextField
            placeholder="Enter here"
            value={customMsg}
            onChange={(e) => handleChange(e)}
            className={classes.textField}
            InputProps={{
              disableUnderline: true,
            }}
          />
        </Grid>
      ) : null}
    </Grid>
  );
}
